import React from 'react';
import { useTranslation } from 'react-i18next';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { useAuth } from '../context/AuthContext';
import { useProBookingProfileUrl } from '../hooks/useProBookingProfileUrl';
import './ProPublicPageHeaderLink.css';

export type ProPublicPageHeaderLinkProps = {
  variant?: 'desktop' | 'mobile';
};

const ProPublicPageHeaderLink: React.FC<ProPublicPageHeaderLinkProps> = ({
  variant = 'desktop',
}) => {
  const { t } = useTranslation('common');
  const { user } = useAuth();
  const proId = user?.pro_id;
  const { bookingUrl } = useProBookingProfileUrl(proId);

  if (!proId || !bookingUrl) {
    return null;
  }

  const label = t('publicPage.headerLabel');
  const aria = t('publicPage.headerAria');

  if (variant === 'mobile') {
    return (
      <a
        href={bookingUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="pro-public-page-link pro-public-page-link--mobile"
        data-rtt-header-public-page="true"
        aria-label={aria}
        title={label}
      >
        <OpenInNewOutlinedIcon fontSize="small" aria-hidden />
      </a>
    );
  }

  return (
    <a
      href={bookingUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="desktop-header-link pro-public-page-link pro-public-page-link--desktop"
      data-rtt-header-public-page="true"
      aria-label={aria}
      title={label}
    >
      <span className="pro-public-page-link__icon-wrap" aria-hidden>
        <OpenInNewOutlinedIcon className="pro-public-page-link__icon" />
      </span>
      <span className="link-text pro-public-page-link__label">{label}</span>
    </a>
  );
};

export default ProPublicPageHeaderLink;
